import React, { useEffect, useState } from "react";
import axios from "axios";
import CalendarHeatmap from "react-calendar-heatmap";
// import "react-calendar-heatmap/dist/styles.css";
import { Tooltip } from "react-tooltip"; // ✅ Correct v5+ import
// import "react-tooltip/dist/react-tooltip.css"; // ✅ Required tooltip styles
import "../Pages/Profile.css"
const Vendorlogs = () => {
  const [data, setData] = useState([]);

  const getVendorLogs = async () => {
    const formData = new FormData();
    formData.append("vendor_id", "1");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/get_vendor_logs.php`,
        formData
      );

      const logs = res.data?.data || [];

      if (Array.isArray(logs)) {
        const formatted = logs.map((entry) => ({
          date: entry.date,
          count: entry.status, // 0 or 1
        }));
        setData(formatted);
      }
    } catch (err) {
      console.error("Error fetching vendor logs:", err);
    }
  };

  useEffect(() => {
    getVendorLogs();
  }, []);

  const today = new Date();
  const yearStart = new Date(today.getFullYear(), 0, 1);

  return (
    <div className="p-4">
      <h3
        style={{
          textDecoration: "underline",
          textUnderlineOffset: "5px",
          color: "lightcoral",
        }}
      >
        Login Activity
      </h3>
      <CalendarHeatmap
        startDate={yearStart}
        endDate={today}
        values={data}
        classForValue={(value) => {
          if (!value || value.count === 0) return "color-empty";
          return `color-github-${Math.min(value.count, 4)}`; // cap at 4
        }}
        tooltipDataAttrs={(value) => {
          if (!value || !value.date) return null;
          return {
            "data-tooltip-id": "heatmap-tooltip",
            "data-tooltip-content": `${value.date} - ${
              value.count === 1 ? "Logged in" : "No login"
            }`,
          };
        }}
        showWeekdayLabels={true}
      />
      <Tooltip id="heatmap-tooltip" /> {/* ✅ Tooltip component */}
    </div>
  );
};

export default Vendorlogs;
